module.exports = __webpack_public_path__ + "img/s7bLogo2.0bc32cff.svg";